export class Credentials {
    clientId: string;
    clientSecret: string;
    separator: string;

    constructor(clientId: string, clientSecret: string, separator: string) {
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.separator = separator;
    }
}

